module.exports = __webpack_public_path__ + "img/sign-out.1b2d6b95.svg";